import actionCreatorFactory from "typescript-fsa";
import { SortOrderRequestBody } from "../../core/api/requests/sortOrder/search/types";
import { CommonAsyncType } from "../../core/types";
import { SortOrder } from "./types";

const actionCreator = actionCreatorFactory("@@SortOrder");

export const sortOrderActions = {
  getSortOrder: actionCreator.async<CommonAsyncType<SortOrder[]> & SortOrderRequestBody, SortOrder[]>("GET_SORT_ORDER"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
